export default __webpack_public_path__ + "static/media/manual2.7daaed7a.docx";